import React, { useEffect, useState } from 'react';
//import IntakeFormsViewer from './IntakeFormsViewer';

function IntakeFormsPopup({
  hide,
  intakeFormList,
  checkedIds,
  setCheckedIds,
  setReopenFlag,
  handleIntakeFormPreview,
}) {
  // State to track checked sub-child ids
  // const [checkedIds, setCheckedIds] = useState(['2', '5']);

  // State to track the checked status of parent checkboxes
  const [parentChecked, setParentChecked] = useState({});
  // const [intakeFromPreviewPopup, setIntakeFromPreviewPopup] = useState(false);
  // const [docsUri, setDocsUri] = useState('');

  useEffect(() => {
    // Update the parent checkboxes based on the checked sub-child checkboxes
    const updatedParentChecked = {};

    intakeFormList &&
      intakeFormList.forEach((form) => {
        const subCatIds = form.subCat.formListArr.map((sub) => sub.intakecatId);
        const allChecked = subCatIds.every((id) => checkedIds.includes(id));

        updatedParentChecked[form.formId] = allChecked;
      });

    setParentChecked(updatedParentChecked);
  }, [checkedIds, intakeFormList]);

  const handleParentCheckboxChange = (formId) => (event) => {
    const isChecked = event.target.checked;
    const subCatIds = intakeFormList
      .find((form) => form.formId === formId)
      .subCat.formListArr.map((sub) => sub.intakecatId);

    setCheckedIds((prev) =>
      isChecked
        ? [...new Set([...prev, ...subCatIds])]
        : prev.filter((id) => !subCatIds.includes(id))
    );
  };

  const handleSubChildCheckboxChange = (formId, intakecatId) => (event) => {
    const isChecked = event.target.checked;

    setCheckedIds((prev) =>
      isChecked
        ? [...new Set([...prev, intakecatId])]
        : prev.filter((id) => id !== intakecatId)
    );
  };

  // const handleIntakeFormPreview = (uri) => {
  //   setDocsUri(uri);
  //   setIntakeFromPreviewPopup(true);
  // };
  return (
    <div>
      <div
        className={`slide-right appt-pt-intake-main-con book-appt-body ${hide}`}
      >
        <span className="appt-pt-intake-hdng">
          ----Select forms for patient online intake------------
        </span>
        <span className="appt-pt-intake-clse">
          <button
            style={{ cursor: 'pointer' }}
            onClick={() => setReopenFlag('0')}
          >
            X
          </button>
        </span>
        <br />
        {intakeFormList &&
          intakeFormList.map((form) => (
            <div key={form.formId}>
              <span className="appt-pt-intk-frm-hdng">
                <input
                  className="left"
                  type="checkbox"
                  checked={parentChecked[form.formId] || false}
                  onChange={handleParentCheckboxChange(form.formId)}
                />
                <span className="left clear-left5"> {form.formName}</span>
              </span>
              <div style={{ paddingLeft: '25px' }}>
                {form.subCat.formListArr.map((sub) => (
                  <span
                    className="appt-pt-intk-frm-sbhdng"
                    key={sub.intakecatId}
                  >
                    <input
                      className="left clear-right10"
                      type="checkbox"
                      checked={checkedIds.includes(sub.intakecatId)}
                      onChange={handleSubChildCheckboxChange(
                        form.formId,
                        sub.intakecatId
                      )}
                    />
                    <span
                      className="left"
                      onClick={() =>
                        handleIntakeFormPreview(sub?.var_name, sub?.parentId)
                      }
                    >
                      {sub.intakecatName}
                    </span>

                    <br />
                  </span>
                ))}
              </div>
            </div>
          ))}
      </div>
      {/* {intakeFromPreviewPopup && (
        <IntakeFormsViewer
          close={() => setIntakeFromPreviewPopup(false)}
          docsUri={docsUri}
        />
      )} */}
    </div>
  );
}

export default IntakeFormsPopup;
